// Invalidated synchronously, before queued storage work can finish.
let sessionVersion = 0
const listeners = new Set<() => void>()

export function getSessionVersion(): number {
	return sessionVersion
}

export function subscribeSessionVersion(listener: () => void): () => void {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}

export function bumpSessionVersion(): void {
	sessionVersion += 1
	for (const listener of listeners) listener()
}

export function assertSessionVersion(version: number): void {
	if (version !== sessionVersion) {
		throw new DOMException("Session ended", "AbortError")
	}
}
